import { EVENTS } from '@/lib/consts.ts'
import { DEFAULT_PAYLOAD } from '@/lib/analytics/consts.ts'

type SegmentHandlerContext = {
  identify: (payload: Record<string, unknown>) => void
} & {
  [DEFAULT_PAYLOAD]: (data: Record<string, unknown>) => Record<string, unknown>
}

export const segment1BooksyCardReader = {
  eventBCRStartedHandler (this: SegmentHandlerContext, data: Record<string, unknown>) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_STARTED,
      ...payload,
    })
    return {
      event: 'BCR_Started',
    }
  },

  eventBCRVerifyHandler (this: SegmentHandlerContext, data: Record<string, unknown>) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_VERIFY,
      ...payload,
    })
    return {
      event: 'BCR_Verify',
    }
  },

  eventBCRStripeKYCStartedHandler (this: SegmentHandlerContext, data: Record<string, unknown>) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_STRIPE_KYC_STARTED,
      ...payload,
    })
    return {
      event: 'BCR_Stripe_KYC_Started',
    }
  },

  eventBCROrderTerminalStartedHandler (this: SegmentHandlerContext, data: Record<string, unknown>) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_ORDER_TERMINAL_STARTED,
      ...payload,
    })

    return {
      event: 'BCR_Order_Terminal_Started',
    }
  },

  eventBCRBuySubscriptionFromBCRHandler (this: SegmentHandlerContext, data: Record<string, unknown>) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_BUY_SUBSCRIPTION_FROM_BCR,
      ...payload,
    })
    return {
      event: 'BCR_Buy_Subscription_From_Bcr',
    }
  },

  eventBCRResetAccountStartedHandler (this: SegmentHandlerContext, data: Record<string, unknown>) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_RESET_ACCOUNT_STARTED,
      ...payload,
    })
    return {
      event: 'BCR_Reset_Account_Started',
    }
  },
}
